// extracted by mini-css-extract-plugin
module.exports = {"MainNavHeader":"Header_MainNavHeader__2vQv3","LogoLink":"Header_LogoLink__2eNXg","Logo":"Header_Logo__21liK"};